<template>
  <div class="supplier-download-page">
    <img
      class="background-image"
      src="@/images/app/supplier_download_bg.png"
    />

    <main class="content">
      <img class="brand-mark" src="@/images/app/logo_supplier.png" />
      <h1>美菜供应商</h1>
      <p>一站式供应商经营服务平台</p>
      <button class="download-button" type="button" @click="onDownload">
        下载应用
      </button>
    </main>

    <div v-if="showWechatTip" class="wechat-tip" @click="showWechatTip = false">
      <div class="wechat-tip-content" @click.stop>
        <span class="arrow"></span>
        请点击右上角，选择“在浏览器打开”后下载
      </div>
    </div>
  </div>
</template>

<script>
import {
  downloadSupplierApp,
  isWechatBrowser
} from '@/utils/supplier_app_download'

export default {
  data() {
    return {
      showWechatTip: false
    }
  },
  methods: {
    async onDownload() {
      if (isWechatBrowser()) {
        this.showWechatTip = true
        return
      }

      try {
        await downloadSupplierApp()
      } catch (error) {
        this.$toast((error && error.message) || '下载失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.supplier-download-page {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background: #fff;
  color: #1d354d;
}

.background-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content {
  display: flex;
  position: relative;
  z-index: 1;
  min-height: 100vh;
  padding: 0 0.64rem;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  transform: translateY(-0.7rem);
}

.brand-mark {
  width: 1.48rem;
  height: 1.48rem;
  margin-bottom: 0.42rem;
  border-radius: 0.32rem;
  box-shadow: 0 0.16rem 0.4rem rgba(21, 137, 50, 0.26);
}

h1 {
  margin: 0;
  font-size: 0.52rem;
  line-height: 1.4;
  color: #fff;
}

p {
  margin: 0.2rem 0 0.74rem;
  font-size: 0.3rem;
  color: #fff;
}

.download-button {
  width: 5.2rem;
  height: 0.96rem;
  padding: 0;
  border: 0;
  border-radius: 0.48rem;
  outline: none;
  background-image: linear-gradient(147deg, #ff8a51 0%, #ff654d 100%);
  box-shadow: 0 0.14rem 0.32rem rgba(21, 137, 50, 0.32);
  font-size: 0.34rem;
  font-weight: bold;
  color: #fff;
}

.wechat-tip {
  position: fixed;
  z-index: 10;
  inset: 0;
  background: rgba(0, 0, 0, 0.62);
}

.wechat-tip-content {
  position: absolute;
  top: 0.8rem;
  right: 0.36rem;
  width: 4.65rem;
  padding: 0.28rem 0.32rem;
  border-radius: 0.12rem;
  background: #fff;
  font-size: 0.28rem;
  line-height: 1.5;
  color: #33495c;
}

.arrow {
  position: absolute;
  top: -0.2rem;
  right: 0.3rem;
  width: 0;
  height: 0;
  border: 0.12rem solid transparent;
  border-bottom-color: #fff;
}
</style>
